import React from 'react';
import ActionDialog from '@src/new-components/Dialog/ActionDialog';
import PaperFireworks from '@src/assets/images/paper-fireworks.svg';

const SubscriptionSuccessPopup = ({
  title,
  description,
  actions,
  onClose,
  open,
}) => (
  <ActionDialog
    open={open}
    title={title}
    styleTitle={{
      textAlign: 'center',
    }}
    contentComponent={description}
    image={PaperFireworks}
    imageContainerSize="80px"
    width="512px"
    actionComponent={actions}
    onClose={onClose}
    style={{ zIndex: 10001, backdropFilter: 'blur(12px)' }}
  />
);

export default SubscriptionSuccessPopup;
